import styled from 'styled-components';
import { colors, layout, remCalc } from '@prisjakt/ui-base';

type SliderRowProps = {
  usePadding?: boolean;
  flex?: boolean;
};
type SliderInputValueProps = {
  visible?: boolean;
};
type SliderInputProps = {
  isValid?: boolean;
  visible?: boolean;
};

export const SliderWrapper = styled.section`
  display: flex;
  flex-direction: column;
  margin: ${layout.spacing.small} ${layout.spacing.small} 0;
`;
export const SliderRow = styled.div<SliderRowProps>`
  display: flex;
  flex-grow: 1;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
`;
export const SliderContainer = styled.div`
  padding: ${layout.spacing.small};
  flex-grow: 1;
  .rheostat {
    display: flex;
    flex-wrap: nowrap;
    flex-direction: row;
    justify-content: stretch;
    align-items: flex-end;
    .handleContainer {
      top: auto;
      bottom: auto;
      left: 0;
    }
  }
`;
const sliderInputStyle = `
  padding: 0 ${layout.spacing.xSmall};
  border: 1px solid ${colors.darkGray1};
  border-radius: 3px;
  margin: 0 0 0.5rem;
  width: 6rem;
  text-align: center;
  font-size: 16px; /* To prevent zoom on iOS focus */
  height: ${remCalc(30)};
  &:focus {
    outline: 0;
  }
`;
export const SliderInputValue = styled.button<SliderInputValueProps>`
  display: ${props => (props.visible === false ? 'none' : 'block')};
  ${sliderInputStyle};
`;
export const SliderInput = styled.input<SliderInputProps>`
  ${sliderInputStyle};
  display: ${props => (props.visible === false ? 'none' : 'block')};
  border-color: ${props => (props.isValid === false ? colors.red1 : 'inherit')};
`;
export const SliderTitle = styled.div`
  padding: ${layout.spacing.xxSmall} ${layout.spacing.xSmall};
`;
export const SliderPit = styled.div`
  position: relative;
  background-color: ${colors.darkBlue1};
  bottom: 4px;
  flex: 1;
`;
export const SliderHandle = styled.div`
  display: block;
  width: 24px;
  height: 24px;
  margin: -12px;
  border-radius: 50%;
  border: 2px solid ${colors.darkBlue1};
  background-color: ${colors.white};
  z-index: 1;
  bottom: 2px;
`;
export const SliderBackground = styled.div`
  position: absolute;
  display: block;
  width: 100%;
  height: 4px;
  border-radius: 0 0 2px 2px;
  background-color: ${colors.darkGray1};
`;
export const SliderProgressBar = styled.div`
  position: absolute;
  display: block;
  width: 100%;
  height: 4px;
  border-radius: 0 0 2px 2px;
  background-color: ${colors.darkBlue1};
`;
